// Shown on every page while /api/me says the app is in preview: the floor
// still works from the Apps Script planner until cutover.
import { Glyph } from "./Glyph";

export function PreviewBanner({ preview, night }: { preview: boolean | undefined; night?: boolean }) {
  if (!preview) return null;
  return (
    <div className={`preview${night ? " preview--night" : ""}`} role="note" data-testid="preview-banner">
      <Glyph name="warn" size={night ? 22 : 14} />
      <span><b>Preview.</b> This isn't the record yet: the floor still works from the Apps Script planner. Prompts go only to the preview list, and the e-paper tags are left alone.</span>
    </div>
  );
}
